import { atom } from 'recoil';

export const currentPageAtom = atom({
  key: 'currentPageAtom',
  default: '',
});
